import React from 'react';

const Home = () => {
  return (
    <div id="home" className="container-fluid text-dark text-center p-5" style={{paddingTop: '100px', backgroundColor: '#E6EBF0'}}>
      <h1 className="display-4 fw-bold">Isentropic College Consulting</h1>
      <p className="lead">Your trusted partner in navigating the college admissions process. We provide personalized guidance to help you achieve your academic goals.</p>
    </div>
  );
};

export default Home;
